import FetchService from "./Shared/FetchService";
import SurveyResponseDomainService from "../Domain/SurveyResponse/SurveyResponse.service";
import SurveyDomainService from "../Domain/Survey/Survey.service";
const baseURL = "/aviso/survey";
export default class SurveyService {
    static searchResponses(search) {
        return FetchService.getSingleResponse(baseURL + "/responses", {
            regardingPersonId: search.regardingPersonPersonId,
        }).then((data) => (Object.assign(Object.assign({}, data), { responses: 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            data.responses &&
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data.responses.map(SurveyResponseDomainService.fromJSON) })));
    }
    static sendSurvey(params) {
        return FetchService.postSingleResponse(baseURL + "/send", {
            surveyId: params.surveyId,
            recipientIds: params.recipientPersonIds,
            regardingId: params.regardingPersonId,
            comments: params.comment,
            virtualizedAppName: params.virtualizedAppName,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((responses) => responses.map(SurveyResponseDomainService.fromJSON));
    }
    static sendSurveyToFilter(params) {
        return FetchService.postSingleResponse(`${baseURL}/sendToFilter`, {
            surveyId: params.surveyId,
            filterId: params.filterId,
            comments: params.comments,
        });
    }
    static sendSurveyToPersonPopulation(params) {
        return FetchService.postSingleResponse(`${baseURL}/sendSurveyToPersonPopulation`, {
            surveyId: params.surveyId,
            populationId: params.populationId,
            comments: params.comments,
        });
    }
    static takeSurvey(params) {
        return FetchService.postSingleResponse(baseURL + "/take", {
            surveyId: params.surveyId,
            recipientId: params.recipientPersonId,
            regardingId: params.regardingPersonId,
            comments: params.comment,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => SurveyResponse' is not assignable to parameter of type '(value: unknown) => SurveyResponse | PromiseLike<SurveyResponse>'.
        }).then(SurveyResponseDomainService.fromJSON);
    }
    static getSurveyResponseDetails(surveyResponseId) {
        return FetchService.getSingleResponse(baseURL + "/responseDetailsJson", {
            id: surveyResponseId,
        }).then((data) => (Object.assign(Object.assign({}, data), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            response: SurveyResponseDomainService.fromJSON(data.response) })));
    }
    static searchRecipientsOfSurveyRegardingPerson(personId, query, max = 20, offset = 0) {
        return FetchService.getSingleResponse(baseURL + "/searchRecipientsOfSurveyRegardingPerson", {
            personId,
            query,
            max,
            offset,
        });
    }
    static list(onlySendableByMe) {
        return FetchService.getSingleResponse(baseURL + "/list", {
            onlySendableByMe,
        });
    }
    static sendToOpportunities({ opportunityIds, surveyId, comments, }) {
        return FetchService.postSingleResponse(baseURL + "/sendToOpportunities", {
            opportunityIds,
            surveyId,
            comments,
        });
    }
    static get(surveyId) {
        return FetchService.getSingleResponse(baseURL + "/get", {
            id: surveyId,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => Survey' is not assignable to parameter of type '(value: unknown) => Survey | PromiseLike<Survey>'.
        }).then(SurveyDomainService.fromJSON);
    }
    static search(search, options = {}) {
        return FetchService.getPagedResponse(baseURL + "/search", {
            ids: search === null || search === void 0 ? void 0 : search.ids,
            srcSystemIds: search === null || search === void 0 ? void 0 : search.srcSystemIds,
            displayNames: search === null || search === void 0 ? void 0 : search.displayNames,
            syncEnabled: search === null || search === void 0 ? void 0 : search.syncEnabled,
            active: search === null || search === void 0 ? void 0 : search.active,
            isKeyEngagement: search === null || search === void 0 ? void 0 : search.isKeyEngagement,
            lastSyncDateFrom: search === null || search === void 0 ? void 0 : search.lastSyncDateFrom,
            lastSyncDateTo: search === null || search === void 0 ? void 0 : search.lastSyncDateTo,
            avisoCollectorIds: search === null || search === void 0 ? void 0 : search.avisoCollectorIds,
            avisoCollectorUrls: search === null || search === void 0 ? void 0 : search.avisoCollectorUrls,
            createdByIds: search === null || search === void 0 ? void 0 : search.createdByIds,
            createdDateFrom: search === null || search === void 0 ? void 0 : search.createdDateFrom,
            createdDateTo: search === null || search === void 0 ? void 0 : search.createdDateTo,
            modifiedDateFrom: search === null || search === void 0 ? void 0 : search.modifiedDateFrom,
            modifiedDateTo: search === null || search === void 0 ? void 0 : search.modifiedDateTo,
            max: options === null || options === void 0 ? void 0 : options.max,
            offset: options === null || options === void 0 ? void 0 : options.offset,
            sort: options === null || options === void 0 ? void 0 : options.sort,
            order: options === null || options === void 0 ? void 0 : options.order,
            query: search === null || search === void 0 ? void 0 : search.query,
        }).then((response) => {
            var _a;
            return (Object.assign(Object.assign({}, response), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: (_a = response.data) === null || _a === void 0 ? void 0 : _a.map(SurveyDomainService.fromJSON) }));
        });
    }
}
